var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15mm",
    height: "15mm",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535353",
    d: "M 0.20397616,14.900335 C 0.09179616,14.777725 6.1560868e-6,11.490795 6.1560868e-6,7.5960449 c 0,-6.99068204 0.00700000391,-7.08562304 0.5946900039132,-7.41554004 0.58193004,-0.32702 6.30230004,-0.195117 12.05103984,0.277877 l 2.1756,0.179004 0.13631,6.42509904 c 0.0749,3.5337901 0.0478,6.6348601 -0.0604,6.8912401 -0.10822,0.25639 -0.59788,0.54804 -1.08814,0.6481 -1.39557,0.28485 -13.37707984,0.54774 -13.60508984,0.29851 z M 11.666316,13.621265 c 1.25621,-0.14639 2.29642,-0.30059 2.31159,-0.3427 0.0152,-0.0421 -0.008,-2.65803 -0.0511,-5.8131601 l -0.0786,-5.736623 -3.32076,-0.334796 C 8.7010262,1.2098479 5.8299362,1.0606599 4.1472462,1.0624579 l -3.05946,0.0032 v 6.523777 6.5237801 l 4.14726,-0.11294 c 2.28098,-0.0621 5.1750498,-0.2327 6.4312498,-0.37909 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#535353",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.2 C2.22 8.6 2.23 9 2.25 9.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95 7.35 C2.91 8.1 2.93 9 2.95 9.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65 6.4 C3.61 7.5 3.62 9.1 3.65 10.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35 5.9 C4.31 7.1 4.32 9 4.35 10.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.05 6.15 C5.02 7.3 5.02 9.1 5.05 10.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 6.55 C5.71 7.5 5.73 9.2 5.75 10.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45 5.75 C6.41 7.2 6.42 9.1 6.45 10.2"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#535353",
    d: "M7.05 5.9 C7.55 5.05 8.4 4.6 9.35 4.7 C10.75 4.85 11.6 5.95 11.55 7.25 C12.55 7.15 13.05 7.95 12.85 8.95 C12.7 9.8 12.05 10.3 11.25 10.3 L7.05 10.3 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.8dd8518495c382b691e26072a868aa66.svg";
export { ForwardRef as ReactComponent };